import React, { useEffect, useState } from 'react';
import CommentThread from '../../../shared/components/comments/CommentThread';
import {
  createStaffNoteResult,
  deleteStaffNoteResult,
  listStaffNotesResult,
} from '../services/staff.service';

export default function StaffNotesPanel({ staffMember }) {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    async function loadNotes() {
      setIsLoading(true);
      setError('');
      const result = await listStaffNotesResult(staffMember.id);
      if (!active) return;
      const ok = result?.ok === true;
      setComments(ok ? result.data : []);
      setError(ok ? '' : result?.message || 'Commenti del personale non disponibili.');
      setIsLoading(false);
    }

    loadNotes();
    return () => {
      active = false;
    };
  }, [staffMember.id]);

  async function submitComment(payload) {
    const body = String(payload?.body || '').trim();
    if (!body || isSubmitting) return { ok: false };

    setIsSubmitting(true);
    setError('');
    const result = await createStaffNoteResult(staffMember.id, body);
    setIsSubmitting(false);

    if (!result.ok) {
      setError(result.message || 'Commento del personale non salvato.');
      return result;
    }

    setComments((prev) => [...prev, result.data]);
    return result;
  }

  async function submitReply(parentId, payload) {
    const body = String(payload?.body || '').trim();
    if (!body || !parentId || isSubmitting) return { ok: false };

    setIsSubmitting(true);
    setError('');
    const result = await createStaffNoteResult(staffMember.id, body, parentId);
    setIsSubmitting(false);

    if (!result.ok) {
      setError(result.message || 'Risposta del personale non salvata.');
      return result;
    }

    setComments((prev) => [...prev, result.data]);
    return result;
  }

  async function deleteComment(comment) {
    const commentId = comment?.id ?? comment;
    const result = await deleteStaffNoteResult(staffMember.id, commentId);
    if (!result.ok) {
      setError(result.message || 'Commento del personale non eliminato.');
      return result;
    }
    setComments((prev) => prev.filter((comment) => String(comment.id) !== String(commentId) && String(comment.parentId) !== String(commentId)));
    return result;
  }

  return (
    <CommentThread
      title="Commenti"
      comments={comments}
      isLoading={isLoading}
      isSubmitting={isSubmitting}
      error={error}
      emptyLabel="Nessun commento del personale."
      placeholder="Aggiungi un commento del personale..."
      submitLabel="Aggiungi commento"
      onSubmitComment={submitComment}
      onSubmitReply={submitReply}
      onDeleteComment={deleteComment}
      allowReplies
      entityType="staff"
      entityId={staffMember.id}
    />
  );
}
